var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMostActiveOwners = function SvgMostActiveOwners(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 48,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    x: "-4.3%",
    y: "-75%",
    width: "108.7%",
    height: "250%",
    filterUnits: "objectBoundingBox",
    id: "most-active-owners_svg__a"
  }, /*#__PURE__*/React.createElement("feOffset", {
    "in": "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    "in": "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.34902 0 0 0 0 0.494118 0 0 0 0 0.968627 0 0 0 0.06 0",
    "in": "shadowBlurOuter1",
    result: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feOffset", {
    "in": "SourceAlpha",
    result: "shadowOffsetOuter2"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5,
    "in": "shadowOffsetOuter2",
    result: "shadowBlurOuter2"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.031373 0 0 0 0 0.039216 0 0 0 0 0.145098 0 0 0 0.05 0",
    "in": "shadowBlurOuter2",
    result: "shadowMatrixOuter2"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    "in": "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    "in": "shadowMatrixOuter2"
  }))), /*#__PURE__*/React.createElement("filter", {
    x: "-4.3%",
    y: "-75%",
    width: "108.7%",
    height: "250%",
    filterUnits: "objectBoundingBox",
    id: "most-active-owners_svg__c"
  }, /*#__PURE__*/React.createElement("feOffset", {
    "in": "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    "in": "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.34902 0 0 0 0 0.494118 0 0 0 0 0.968627 0 0 0 0.06 0",
    "in": "shadowBlurOuter1",
    result: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feOffset", {
    "in": "SourceAlpha",
    result: "shadowOffsetOuter2"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5,
    "in": "shadowOffsetOuter2",
    result: "shadowBlurOuter2"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.031373 0 0 0 0 0.039216 0 0 0 0 0.145098 0 0 0 0.05 0",
    "in": "shadowBlurOuter2",
    result: "shadowMatrixOuter2"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    "in": "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    "in": "shadowMatrixOuter2"
  }))), /*#__PURE__*/React.createElement("filter", {
    x: "-4.3%",
    y: "-75%",
    width: "108.7%",
    height: "250%",
    filterUnits: "objectBoundingBox",
    id: "most-active-owners_svg__e"
  }, /*#__PURE__*/React.createElement("feOffset", {
    "in": "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    "in": "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.349019608 0 0 0 0 0.494117647 0 0 0 0 0.968627451 0 0 0 0.06 0",
    "in": "shadowBlurOuter1",
    result: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feOffset", {
    "in": "SourceAlpha",
    result: "shadowOffsetOuter2"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5,
    "in": "shadowOffsetOuter2",
    result: "shadowBlurOuter2"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.031372549 0 0 0 0 0.0392156863 0 0 0 0 0.145098039 0 0 0 0.05 0",
    "in": "shadowBlurOuter2",
    result: "shadowMatrixOuter2"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    "in": "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    "in": "shadowMatrixOuter2"
  }))), /*#__PURE__*/React.createElement("rect", {
    id: "most-active-owners_svg__b",
    x: 11,
    y: 22,
    width: 69,
    height: 4,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "most-active-owners_svg__d",
    x: 11,
    y: 3,
    width: 69,
    height: 4,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "most-active-owners_svg__f",
    x: 11,
    y: 41,
    width: 69,
    height: 4,
    rx: 2
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    filter: "url(#most-active-owners_svg__a)",
    xlinkHref: "#most-active-owners_svg__b"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#BAE637",
    xlinkHref: "#most-active-owners_svg__b"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    filter: "url(#most-active-owners_svg__c)",
    xlinkHref: "#most-active-owners_svg__d"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#37A3BC",
    xlinkHref: "#most-active-owners_svg__d"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    filter: "url(#most-active-owners_svg__e)",
    xlinkHref: "#most-active-owners_svg__f"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#FFC53D",
    xlinkHref: "#most-active-owners_svg__f"
  }), /*#__PURE__*/React.createElement("text", {
    fontFamily: "NunitoSans-Black, Nunito Sans",
    fontSize: 10,
    fontWeight: 700,
    fill: "#37A3BC"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 1,
    y: 10
  }, "1")), /*#__PURE__*/React.createElement("text", {
    fontFamily: "NunitoSans-Black, Nunito Sans",
    fontSize: 10,
    fontWeight: 700,
    fill: "#BAE637"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 1,
    y: 29
  }, "2")), /*#__PURE__*/React.createElement("text", {
    fontFamily: "NunitoSans-Black, Nunito Sans",
    fontSize: 10,
    fontWeight: 700,
    fill: "#FFC53D"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 1,
    y: 48
  }, "3")))));
};
export default SvgMostActiveOwners;